import { Component, forwardRef, input } from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormOption } from 'src/app/shared/models/form-option.model';

import { CheckboxModule } from 'primeng/checkbox';
import { TableModule } from 'primeng/table';
import { WNL_HOST_CONTROL, WnlHostControl, WnlHostType } from 'src/app/shared/tokens/wnl-host-control.token';

/**
 * Component to help manage multi-select form inputs. It generates a list
 * of checkboxes, with each checkbox associated with an option.
 * Each checkbox that is checked adds its value to the passed FormControl, whic
 * is assumed to be an array.
 *
 * To see examples where this component is used, visit some of the classes that extend the
 * AssessmentFormComponent class (e.g. Neurological, Genitourinary, Musculoskeletal).
 */
@Component({
  selector: 'emr-checkbox-group',
  templateUrl: './emr-checkbox-group.component.html',
  styleUrls: ['./emr-checkbox-group.component.scss'],
  standalone: true,
  providers: [
    {
      provide: WNL_HOST_CONTROL,
      useExisting: forwardRef(() => EmrCheckboxGroupComponent),
    },
  ],
  imports: [
    CheckboxModule,
    TableModule,
    FormsModule,
    ReactiveFormsModule
],
})
export class EmrCheckboxGroupComponent implements WnlHostControl {
  /**
   * Label that describes to the user what the input is for.
   */
  label = input('');

  /**
   * The options that will be rendered next to checkboxes.
   */
  options = input<FormOption[]>([]);

  /**
   * The control for which the checkboxes add or remove values.
   */
  control = input<UntypedFormControl>(new UntypedFormControl());

  constructor() { }

  getWnlControl(): UntypedFormControl | null {
    return this.control();
  }

  getWnlHostType(): WnlHostType {
    return 'checkbox-group';
  }
}
